import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";

export function getFollowingListById(token, api_token, user_id, pageNumber, query, filter_by) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/following/${user_id}?api_token=${api_token}&page=${pageNumber}&filter_by=${filter_by}&query=${query}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.FOLLOWING_LIST_FOR_OTHERS_REQUEST, types.FOLLOWING_LIST_FOR_OTHERS_RECEIVE, {
                type: types.FOLLOWING_LIST_FOR_OTHERS_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetGetFollowingListById = () => ({
    type: types.RESET_FOLLOWING_LIST_FOR_OTHERS,
    payload: null
});